import PropTypes from 'prop-types';
import classNames from 'classnames';
import StatisticsFullscreenIcon from '../StatisticsFullscreenIcon';
import { CHART_CARD_SURFACE } from './chartCard.js';

const getActionClassName = (kind) =>
	classNames(
		'statistics-chart-card__action',
		kind === 'text' && 'statistics-chart-card__action--text',
		kind === 'icon' && 'statistics-chart-card__action--icon',
		kind === 'danger' && 'statistics-chart-card__action--danger',
	);

export function StatisticsChartCardToolbar({ surface = CHART_CARD_SURFACE.PRESET, children, className, ariaLabel = '图表操作' }) {
	return (
		<div className={classNames('statistics-chart-card__toolbar', className)} role='toolbar' aria-label={ariaLabel} data-chart-card-surface={surface}>
			{children}
		</div>
	);
}

StatisticsChartCardToolbar.propTypes = {
	surface: PropTypes.oneOf(Object.values(CHART_CARD_SURFACE)),
	children: PropTypes.node,
	className: PropTypes.string,
	ariaLabel: PropTypes.string,
};

export function StatisticsChartCardAction({ surface = CHART_CARD_SURFACE.PRESET, kind = 'icon', onClick, title, disabled = false, className, children }) {
	return (
		<button
			type='button'
			className={classNames(getActionClassName(kind), className)}
			onClick={onClick}
			disabled={disabled}
			title={title}
			aria-label={title ?? undefined}
			data-chart-card-surface={surface}
		>
			{children}
		</button>
	);
}

StatisticsChartCardAction.propTypes = {
	surface: PropTypes.oneOf(Object.values(CHART_CARD_SURFACE)),
	kind: PropTypes.oneOf(['icon', 'text', 'danger']),
	onClick: PropTypes.func,
	title: PropTypes.string,
	disabled: PropTypes.bool,
	className: PropTypes.string,
	children: PropTypes.node,
};

export function StatisticsChartCardFullscreenAction({ surface = CHART_CARD_SURFACE.PRESET, onClick, title = '全屏查看', iconSize }) {
	const resolvedIconSize = iconSize ?? (surface === CHART_CARD_SURFACE.SNAPSHOT ? 17 : 15);

	return (
		<StatisticsChartCardAction surface={surface} kind='icon' onClick={onClick} title={title}>
			<StatisticsFullscreenIcon size={resolvedIconSize} />
		</StatisticsChartCardAction>
	);
}

StatisticsChartCardFullscreenAction.propTypes = {
	surface: PropTypes.oneOf(Object.values(CHART_CARD_SURFACE)),
	onClick: PropTypes.func.isRequired,
	title: PropTypes.string,
	iconSize: PropTypes.number,
};
